import axios from '@/api/http';
import base from '@/api//base';
const course = {
	// 分页请求所有数据-课程
	CoursePage(params){
		return axios.post(`${base.baseURL}/Course/page`,params);
	},
	// 新增数据-课程
	CourseInsert(params){
		return axios.post(`${base.baseURL}/Course/insert`,params);
	},
	// 修改数据-课程
	CourseUpdate(params){
		return axios.post(`${base.baseURL}/Course/update`,params);
	},
	// 删除数据-课程
	CourseDeleteById(id){
		return axios.post(`${base.baseURL}/Course/delete/${id}`);
	},
	// 分页请求所有数据-章节
	ChapterPage(params){
		return axios.post(`${base.baseURL}/Chapter/page`,params);
	},
	// 新增数据-课程
	ChapterInsert(params){
		return axios.post(`${base.baseURL}/Chapter/insert`,params);
	},
	// 修改数据-课程
	ChapterUpdate(params){
		return axios.post(`${base.baseURL}/Chapter/update`,params);
	},
	// 删除数据-课程
	ChapterDeleteById(id){
		return axios.post(`${base.baseURL}/Chapter/delete/${id}`);
	},
}
export default course;



// WEBPACK FOOTER //
// ./src/network/course.js